import { BasicTabs, IBasicTabs, AccessCheck } from "@components";
import { UploadInitFile } from "features/dataSync/components/UploadInitFile";
import { UploadSyncFile } from "features/dataSync/components/UploadSyncFile";
import { GenerateTranslations } from "features/dataSync/components/GenerateTranslations";
import { UserRoleEnum } from "features/users/types";

export const SyncPage = () => {
  const tabs: IBasicTabs = [
    ["Translations task", <GenerateTranslations />],
    ["Upload synchronization", <UploadSyncFile />],
    ["Upload initialization", <UploadInitFile />],
  ];

  return (
    <AccessCheck minAccessLevel={UserRoleEnum.Admin}>
      <BasicTabs tabs={tabs} />
    </AccessCheck>
  );
};

export default SyncPage;
